<template>
  <ul class="flex flex-col gap-1 text-sm">
    <li v-if="serverId">
      <div class="font-bold">Server ID</div>
      <clipboard-copy icon-mode="hover" copy-on="all" :content="serverId"> </clipboard-copy>
    </li>
    <li v-if="sid">
      <div class="font-bold">Service ID</div>
      <clipboard-copy icon-mode="hover" copy-on="all" :content="sid"> </clipboard-copy>
    </li>
    <li v-if="hwId">
      <div class="font-bold">Hardware</div>
      <div>
        <clipboard-copy icon-mode="hover" copy-on="icon" :content="hwId">
          <a :href="`${adminPanelUrl}/system/view/${hwId}`" target="_blank">{{ hwId }}</a>
        </clipboard-copy>
      </div>
      <div v-if="guacamoleUrl">
        <a :href="guacamoleUrl" target="_blank">
          Guacamole <font-awesome-icon class="ml-1" :icon="faExternalLinkAlt" />
        </a>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useServiceStore } from "../../store/service";
import { useWiUtils } from "../../util/webinterface";
import ClipboardCopy from "../util/ClipboardCopy.vue";

const service = useServiceStore();
const { adminPanelUrl } = useWiUtils();

const sid = computed(() => service.ctx.service?.config?.rsid.id);
const serverId = computed(() => service.ctx.sys?.gameServer?.id);
const hwId = computed(() => service.ctx.service?.config?.hwId);
const guacamoleUrl = computed(() => service.ctx.admin?.hardwareGuacamoleConnection?.url);
</script>
